module.exports = __webpack_public_path__ + "static/meteorite-logo-2bda28a78b14c5e8133834ea3880131c.png";